// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  invoices: null,
  invoice: null,
  finance: null,
  creditNote: null,
  creditNotes: null,
  payments: null,
  statements: null,
  order: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isNoonInvoiceLoading: false,
  isCreditNotesLoading: false,
  isPaymentsLoading: false,
  isFinanceLoading: false,
  isOrderLoading: false,
  isExportLoading: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get invoices */
export const getInvoices = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getInvoicesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    invoices: action.invoices,
    isLoading: false
  };
};

export const getInvoicesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Get invoices */
export const getInvoicesNoon = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isNoonInvoiceLoading: true
  };
};

export const getInvoicesNoonSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    invoices: action.invoices,
    isNoonInvoiceLoading: false
  };
};

export const getInvoicesNoonFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isNoonInvoiceLoading: false,
  errorMessage: action.error || genericError
});

/* Get credit notes */
export const getCreditNotes = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isCreditNotesLoading: true
  };
};

export const getCreditNotesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    creditNotes: action.creditNotes,
    isCreditNotesLoading: false
  };
};

export const getCreditNotesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isCreditNotesLoading: false,
  errorMessage: action.error || genericError
});

/* Get payments */
export const getPayments = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isPaymentsLoading: true
  };
};

export const getPaymentsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    payments: action.payments,
    isPaymentsLoading: false
  };
};

export const getPaymentsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isPaymentsLoading: false,
  errorMessage: action.error || genericError
});

/* Get payments */
export const getPaymentDetails = (state: Object = INITIAL_STATE, actions) => {
  const params = URLSearchParams ? new URLSearchParams(actions.query) : "";
  return {
    ...state,
    isPaymentsLoading: true,
    currentPage: params && params.get("page")
  };
};

export const getPaymentDetailsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const obj = {
    ...state,
    isPaymentsLoading: false,
    payments: state.payments
  };
  console.log("SAAAA", obj);
  if (
    action.payments &&
    action.payments.statement &&
    action.payments.statement.items &&
    action.payments.statement.items.length > 0 &&
    obj.payments &&
    obj.payments.statement &&
    obj.payments.statement.items &&
    obj.payments.statement.items.length > 0 &&
    state.currentPage > 1
  ) {
    for (let i = 0; i < action.payments.statement.items.length; i++)
      obj.payments.statement.items.push(action.payments.statement.items[i]);
  } else {
    obj.payments = action.payments;
  }
  return obj;
};

export const getPaymentDetailsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isPaymentsLoading: false,
  errorMessage: action.error || genericError
});

/* Get Financial View */
export const getFinanceView = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isFinanceLoading: true
  };
};

export const getFinanceViewSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    finance: action.finance,
    isFinanceLoading: false
  };
};

export const getFinanceViewFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isFinanceLoading: false,
  errorMessage: action.error || genericError
});

/* Get Order View */
export const getOrderView = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isOrderLoading: true
  };
};

export const getOrderViewSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    order: action.order,
    isOrderLoading: false
  };
};

export const getOrderViewFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isOrderLoading: false,
  errorMessage: action.error || genericError
});

/* Export CreditNote */
export const exportCreditNote = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isExportLoading: true
  };
};

export const exportCreditNoteSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    creditNote: action.creditNote,
    isExportLoading: false
  };
};

export const exportCreditNoteFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isExportLoading: false,
  errorMessage: action.error || genericError
});

/* Export Invoice */
export const exportInvoice = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isExportLoading: true
  };
};

export const exportInvoiceSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    invoice: action.invoice,
    isExportLoading: false
  };
};

export const exportInvoiceFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isExportLoading: false,
  errorMessage: action.error || genericError
});

/* Export Invoice */
export const exportStatements = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isExportLoading: true
  };
};

export const exportStatementsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    statements: action.statements,
    isExportLoading: false
  };
};

export const exportStatementsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  isExportLoading: action.error || genericError
});

const ACTION_HANDLERS = {
  [Types.GET_INVOICES]: getInvoices,
  [Types.GET_INVOICES_SUCCESS]: getInvoicesSuccess,
  [Types.GET_INVOICES_FAILURE]: getInvoicesFailure,
  [Types.GET_INVOICES_NOON]: getInvoicesNoon,
  [Types.GET_INVOICES_NOON_SUCCESS]: getInvoicesNoonSuccess,
  [Types.GET_INVOICES_NOON_FAILURE]: getInvoicesNoonFailure,
  [Types.GET_CREDIT_NOTES]: getCreditNotes,
  [Types.GET_CREDIT_NOTES_SUCCESS]: getCreditNotesSuccess,
  [Types.GET_CREDIT_NOTES_FAILURE]: getCreditNotesFailure,
  [Types.GET_PAYMENTS]: getPayments,
  [Types.GET_PAYMENTS_SUCCESS]: getPaymentsSuccess,
  [Types.GET_PAYMENTS_FAILURE]: getPaymentsFailure,
  [Types.GET_PAYMENT_DETAILS]: getPaymentDetails,
  [Types.GET_PAYMENT_DETAILS_SUCCESS]: getPaymentDetailsSuccess,
  [Types.GET_PAYMENT_DETAILS_FAILURE]: getPaymentDetailsFailure,
  [Types.GET_FINANCE_VIEW]: getFinanceView,
  [Types.GET_FINANCE_VIEW_SUCCESS]: getFinanceViewSuccess,
  [Types.GET_FINANCE_VIEW_FAILURE]: getFinanceViewFailure,
  [Types.GET_ORDER_VIEW]: getOrderView,
  [Types.GET_ORDER_VIEW_SUCCESS]: getOrderViewSuccess,
  [Types.GET_ORDER_VIEW_FAILURE]: getOrderViewFailure,
  [Types.EXPORT_CREDIT_NOTE]: exportCreditNote,
  [Types.EXPORT_CREDIT_NOTE_SUCCESS]: exportCreditNoteSuccess,
  [Types.EXPORT_CREDIT_NOTE_FAILURE]: exportCreditNoteFailure,
  [Types.EXPORT_INVOICE]: exportInvoice,
  [Types.EXPORT_INVOICE_SUCCESS]: exportInvoiceSuccess,
  [Types.EXPORT_INVOICE_FAILURE]: exportInvoiceFailure,
  [Types.EXPORT_STATEMENTS]: exportStatements,
  [Types.EXPORT_STATEMENTS_SUCCESS]: exportStatementsSuccess,
  [Types.EXPORT_STATEMENTS_FAILURE]: exportStatementsFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/StatementsReducer.js